<template>
  <div class="flex gap-2 flex-wrap items-center">
    <template v-if="type === 'dashboard'">
      <template v-for="(item, index) in tabs" :key="index">
        <button
          v-if="isDashboardTab(item) ? shouldShowTab(item.cleaned_key) : true"
          class="px-3 py-2 bg-white text-sm border-none rounded-[10px] flex items-center justify-center gap-[10px] h-max whitespace-nowrap"
          :class="{
            active_tab: isDashboardTab(item) ? current_tab === item.key : false,
          }"
          :disabled="isDashboardTab(item) ? current_tab == item.key : false"
          @click.prevent="isDashboardTab(item) ? switchOrdersTab(item.apiKey, item.key) : null"
        >
          <p class="leading-none mt-[2px]">
            {{ isDashboardTab(item) ? item.display_name : 'No Name' }}
          </p>
          <span
            class="badge badge-light p-1 px-2 bg-[#DEEDFF] text-xs text-[#330FC2] font-bold rounded-[4px]"
            >{{ isDashboardTab(item) ? item.count : 0 }}</span
          >
        </button>
      </template>
    </template>
    <template v-else>
      <div class="flex border-b border-gray-200 w-max gap-5">
        <template v-for="(tab, idx) in tabs" :key="isModeTab(tab) ? tab.id : idx">
          <button
            v-if="isModeTab(tab)"
            class="flex-1 text-center py-3 font-semibold text-base transition-colors duration-200 relative bg-transparent outline-none border-none"
            :class="[
              currentTab === tab.id ? 'text-primary font-bold' : 'text-gray-500 hover:text-primary',
              'mode-tab-btn',
            ]"
            @click.prevent="switchTab(tab.id)"
          >
            <component
              v-if="tab.icon"
              :is="tab.icon"
              class="size-5 inline-block align-middle mr-1"
            />
            <span>{{ tab.label }}</span>
            <span
              v-if="currentTab === tab.id"
              class="absolute left-0 bottom-0 w-full h-0.5 bg-primary rounded transition-all duration-200"
            ></span>
          </button>
        </template>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { can } from '@/composables/';
import { DashboardTab } from '@/models';
import { onMounted, ref } from 'vue';
interface Props {
  tabs: DashboardTab[] | { id: string; label: string; icon?: any }[];
  currentTab: string;
  type?: 'dashboard' | 'mode';
}
const props = defineProps<Props>();

const emit = defineEmits(['tab-change']);
const current_tab = ref<string>('all_items_count');

// Function to check permissions
const shouldShowTab = (cleaned_key: string): boolean => {
  if (
    cleaned_key === 'pending_for_factory_assignment' &&
    can('assign-factory-to-shareable-orders')
  ) {
    return true;
  }
  // else if (cleaned_key === 'quote_requested' && can('show-quotes-tab')) {
  //   return true;
  // }
  // else if (cleaned_key === 'unresolved_comments' && can('can-resolve-comment')) {
  //   return true;
  // }
  else if (
    cleaned_key === 'pending_merchant_approval' ||
    // cleaned_key === 'urgent_action' ||
    // cleaned_key === 'customer_await' ||
    // cleaned_key === 'pending' ||
    // cleaned_key === 'completed' ||
    // cleaned_key === 'cancelled' ||
    // cleaned_key === 'shipped' ||
    // cleaned_key === 'reorders' ||
    cleaned_key === 'my_orders' ||
    cleaned_key === 'all'
  ) {
    return true; // No specific permission needed
  }
  return false; // Default: hide tab
};

// Function to switch tabs
const switchOrdersTab = (tabKey: string, orgKey: string) => {
  current_tab.value = orgKey;
  emit('tab-change', tabKey);
};
function switchTab(key: string) {
  emit('tab-change', key);
}

// Add type guards
function isDashboardTab(tab: any): tab is DashboardTab {
  return 'cleaned_key' in tab && 'key' in tab && 'apiKey' in tab;
}
function isModeTab(tab: any): tab is { id: string; label: string; icon?: any } {
  return 'id' in tab && 'label' in tab;
}

onMounted(() => {
  current_tab.value = props.currentTab ? `${props.currentTab}_count` : 'all_items_count';
});
</script>

<style lang="scss">
.active_tab {
  background-color: #00b087;
  color: #fff;
}
.mode-tab-btn {
  border-radius: 0;
  background: none;
  position: relative;
  border: none;
  cursor: pointer;
  margin-bottom: -1px;
}
.mode-tab-btn:focus {
  outline: none;
}
.mode-tab-btn:hover {
  background: none;
  color: #00b087;
}
.text-primary {
  color: #00b087;
}
.bg-primary {
  background-color: #00b087;
}
</style>
